import React from 'react'
import shortid from 'shortid'
import { Observable } from 'rxjs'
import { Oops } from 'components'
import { ActionTypes } from 'unity-core'

const __webpack__ = __webpack_require__ || a
const TARGET = process.env.npm_lifecycle_event

export const initModule = async (module) => {
    //sync reducers
    const reducers = module.Reducers
    if (reducers) {
        window.__asyncReducers = _.merge(window.__asyncReducers, reducers)
    }
    //sync sagas 
    const sagas = module.Sagas
    if (sagas) {
        let asyncSagas = _.filter((window.__asyncSagas || []), x => x.bundle != module.MODULE_BUNDLE)
        asyncSagas.push({ bundle: module.MODULE_BUNDLE, sagas: sagas })
        window.__asyncSagas = asyncSagas
    }
    //sync lang
    let i18n = module.i18n
    if (i18n) {
        const windowLangs = Object.entries(window.__lang).map(([key, val]) => ({ key, ...val }));
        const moduleLangs = Object.entries(i18n).map(([key, val]) => ({ key, ...val }));

        if(windowLangs.length != moduleLangs.length){
            windowLangs.forEach(lang => {
                
                if(!i18n[lang.key]){
                    console.warn(`Language '${lang.key}' not found for module. Fallbacking to english.`);
                    i18n = {
                        ...i18n,
                        [lang.key]: i18n['en-us']
                    }
                }
            });
        }

        window.__lang = _.merge(window.__lang, i18n)
    }
    //load css
    var cssId = 'style-' + module.MODULE_BUNDLE;
    if (!document.getElementById(cssId)) {
        var head = document.getElementsByTagName('head')[0];
        var link = document.createElement('link');
        link.id = cssId;
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = `/${module.MODULE_BUNDLE}.css?${shortid.generate()}`;
        link.media = 'all';
        head.appendChild(link);
    }
    //sync env
    const getEnv = module.getEnv
    if (getEnv) {
        window.__environment = _.merge(window.__environment, getEnv(TARGET))
    }
}

const initStore = async () => {
    const { createReducer, createSagas, sagaMiddleware } = await import('unity-core')
    //reducers
    let combinedReducers = createReducer(window.__asyncReducers)
    window.__store.replaceReducer(combinedReducers)
    //sagas
    window.__sagaTask.cancel()
    window.__sagaTask.done.then(() => {
        window.__sagaTask = sagaMiddleware.run(function* replacedSaga() {
            yield createSagas(_.map(window.__asyncSagas, x => { return x.sagas }))
        })
    })
}

export const reloadModuleBundle = async (bundle) => {
    await window.__store.dispatch({ type: ActionTypes.App.TOGGLE_APP_UPDATE, payload: true })
    let updates = window.__store.getState().app.updates
    let index = _.findIndex(updates, { bundle: bundle })
    if (index != -1)
        updates.splice(index, 1)
    await loadDevModuleBundle({ bundle, reload: true })
    console.log('update completed')
    await window.__store.dispatch({ type: ActionTypes.App.TOGGLE_APP_UPDATE, payload: false })
    await window.__store.dispatch({ type: ActionTypes.App.REFRESH_APP_UPDATES, payload: _.clone(updates) })
}

export const loadDevModuleBundle = async ({ bundle, progress, observer, init_store = true, reload = false }) => {
    let key = `__${bundle}_module_loaded`
    if (!window[key] || reload) {
        if (observer) observer.next({ bundle, progress })
        let meta = await new Promise(resolve => window.require([`json!${bundle}.json?${shortid.generate()}`], (x) => resolve(x), (x) => { console.error(`>> failed load manifest of bundle ${bundle}, ${x.toString()}`); resolve() }))
        if (!meta) return false
        let loaded = await new Promise(resolve => window.require([`${bundle}.bundle.js?${meta.version}`], () => resolve(true), (x) => { console.error(`>> failed load bundle ${bundle}, ${x.toString()}`); resolve(false) }))
        if (!loaded) return false
        //@@@Install Module@@//
        let newModules = window.webpackJsonp[window.webpackJsonp.length - 1][1]
        // console.log('installedModules', __webpack__.c)
        // console.log('newModules', newModules)
        if (reload) {
            let res = _.filter(_.keys(__webpack__.c), x => x.startsWith(meta.mountPath))
            res.forEach(x => delete __webpack__.c[x])
        }
        //entry
        let moduleId = meta.mountPath + '/module.jsx'
        let module = __webpack__.c[moduleId] = {
            i: moduleId,
            l: false,
            exports: {}
        };
        try {
            newModules[moduleId].call(module.exports, module, module.exports, __webpack__);
        } catch (x) {
            console.error(`>> failed init bundle ${bundle},`, x);
            delete __webpack__.c[moduleId]
            return false
        }
        module.l = true;
        //@@@Init Module@@//
        await initModule(module.exports)
        if (init_store) await initStore()
        //@@@Finalize@@//
        window[key] = { loaded: true, ...meta }
        console.log(`>>>>> bundle ${bundle} (${meta.version}) loaded`)
        return true
    }
    return true
}

export const loadAllBundles = async (onNext, onComplete) => {
    const loader$ = new Observable(async observer => {
        let modules = await new Promise(resolve => window.require([`json!modules.json?${shortid.generate()}`], (x) => resolve(x), (x) => { console.error(`failed load modules.json, ${x.toString()}`); resolve({}) }))
        modules = _.filter(modules, x => x.enabled && !x.external)
        var i = 1
        for (let m of modules) {
            await loadDevModuleBundle({ bundle: m.bundle, observer, init_store: false, progress: { current: m.name, pos: i, total: modules.length } }) //'build:dev'
            i++
        }
        await initStore()
        observer.complete()
    })
    const sub = loader$.subscribe(
        x => { if (onNext) onNext(x) },
        null,
        () => { sub.unsubscribe(); if (onComplete) onComplete() }
    )
}

export const isLoaded = (bundle) => {
    let loaded = window[`__${bundle}_module_loaded`]
    return loaded != null
}

export const loadModule = (bundle) => {
    let loaded = window[`__${bundle}_module_loaded`]
    if (!loaded) return null
    const x = __webpack__.c[loaded.mountPath + '/module.jsx'].exports
    return x
}

export const loadModuleIndexRoute = (meta, loc, cb) => {
    if (loc.location.action == 'POP') {
        const x = loadModule(meta.bundle)
        if (x == null)
            cb(null, { getComponent: (state, cb) => cb(null, props => <Oops {...props} meta={meta} />) })
        else
            cb(null, x.Routing(x.default).IndexRoute)
    }
}

export const loadModuleChildRoutes = (meta, loc, cb) => {
    if (loc.location.action == 'POP') {
        const x = loadModule(meta.bundle)
        if (x == null)
            cb(null, [{ path: '*', getComponent: (state, cb) => cb(null, props => <Oops {...props} meta={meta} />) }])
        else
            cb(null, x.Routing(x.default).ChildRoutes)
    }
}